import client from "libs/HttpClient";

/**
 * Service class for handling payment.
 */
class PhonePayPaymentService {
  /**
   * Adds a new Phone pay Payment based on the provided request.
   *
   * @param request - The request parameters for adding a Phone pay payment.
   * @returns A Promise that resolves to the Axios response for the add Phone pay payment request.
   */
  static storePhonePayPayment(request: any) {
    return client.post("admin/phone-pay/payment", request);
  }

  /**
   * Adds a new Phone pay Payment By Guest based on the provided request.
   *
   * @param request - The request parameters for adding a Phone pay payment.
   * @returns A Promise that resolves to the Axios response for the add Phone pay payment request.
   */
  static storePhonePayPaymentByGuest(request: any) {
    return client.post("admin/phone-pay/guest-payment", request);
  }
}

export { PhonePayPaymentService };
